import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Container,
  Grid,
  Alert,
  Paper,
  LinearProgress,
  Fade,
} from "@mui/material";

import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import Header from "../../components/layout/Header";
import Sidebar from "../../components/layout/Sidebar";
import ImageToOrder from "../../components/order/ImageToOrder";
import { getImgOrderCreditData } from "../../redux/actions/ImageToOrderActions";

const ImageToOrderPage = ({ nav }) => {
  const dispatch = useDispatch();
  const { loading, error, creditRecord } = useSelector(
    (state) => state.ImgOrderCredit
  );

  useEffect(() => {
    dispatch(getImgOrderCreditData());
  }, [dispatch]);

  return (
    <Box className={nav.isSidebar}>
      <Header nav={nav} />
      <Sidebar nav={nav} />

      <Container maxWidth="lg" sx={{ mt: 10, mb: 4 }}>
        {/* Modern Breadcrumbs */}
        <nav
          aria-label="breadcrumb"
          style={{ marginBottom: "16px", marginTop: "16px" }}
        >
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/" color="primary">
                <i className="bx bx-home-alt" /> Home
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Create New Order With Image
            </li>
          </ol>
        </nav>

        {/* Loading State */}
        {loading && (
          <Box sx={{ width: "100%", mb: 3 }}>
            <LinearProgress />
          </Box>
        )}

        {/* Error State */}
        {error && (
          <Fade in>
            <Alert
              severity="error"
              sx={{
                mb: 3,
                boxShadow: 1,
                "& .MuiAlert-message": {
                  fontSize: "1rem",
                },
              }}
            >
              {error}
            </Alert>
          </Fade>
        )}

        {/* Credit Information Card */}
        <Card
          sx={{
            mb: 4,
            background: "linear-gradient(135deg, #fff 0%, #f5f5f5 100%)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
            borderRadius: 2,
            transition: "transform 0.2s ease-in-out",
            "&:hover": {
              transform: "translateY(-4px)",
            },
          }}
        >
          <CardContent sx={{ py: 3 }}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <AccountBalanceWalletIcon
                  sx={{
                    fontSize: 40,
                    color:
                      creditRecord?.totalCredits > 0
                        ? "success.main"
                        : "error.main",
                  }}
                />
              </Grid>
              <Grid item xs>
                <Typography variant="h6" fontWeight="500">
                  Available Credits
                </Typography>
                <Typography
                  variant="h3"
                  color={
                    creditRecord?.totalCredits > 0
                      ? "success.main"
                      : "error.main"
                  }
                  fontWeight="700"
                >
                  {creditRecord?.totalCredits || 0}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Main Content */}
        <Fade in timeout={500}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            
              <Box sx={{ p: 3 }}>
                <ImageToOrder totalCredits={creditRecord?.totalCredits} />
              </Box>
        
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default ImageToOrderPage;
